import { call, takeLatest, put } from "redux-saga/effects";
import {
  getAcquiredPropertiesPage,
  getAcquiredPropertiesList,
} from "network/services/acquiredAssets";
import {
  getAcquiredPropertiesPageDataFailed,
  getAcquiredPropertiesPageDataSuccess,
} from "../actionCreators";
import { ISaga, AutoLoansData } from "../types";

const SAMPLE_PROPERTIES = [
  {
    name: "BGC Property For Sale",
    body: "",
    field_city: "Makati",
    field_floor_area: "1000",
    field_location_properties: "NCR",
    field_lot_area: "1000",
    field_property_image:
      "/sites/default/files/2023-08/638037cab8fcb25cb2e8ad4d_webaliser-_TPTXZd9mOo-unsplash-p-500.jpg",
    field_property_no: "2",
    field_type: "Residential Area",
    field_price: "1,000,321,000",
  },
  {
    name: "Luxury Condo in Makati",
    body: "",
    field_city: "Makati",
    field_floor_area: "1200",
    field_location_properties: "NCR",
    field_lot_area: "1200",
    field_property_image:
      "/sites/default/files/2023-08/638037cab8fcb25cb2e8ad4d_webaliser-_TPTXZd9mOo-unsplash-p-500.jpg",
    field_property_no: "3",
    field_type: "Townhouse",
    field_price: "1,200,000",
  },
  {
    name: "Suburban Home in Quezon City",
    body: "",
    field_city: "Quezon City",
    field_floor_area: "1800",
    field_location_properties: "NCR",
    field_lot_area: "2000",
    field_property_image:
      "/sites/default/files/2023-08/638037cab8fcb25cb2e8ad4d_webaliser-_TPTXZd9mOo-unsplash-p-500.jpg",
    field_property_no: "4",
    field_type: "Vacant Lot",
    field_price: "1,800,000",
  },
  {
    name: "Downtown Apartment in Manila",
    body: "",
    field_city: "Manila",
    field_floor_area: "900",
    field_location_properties: "NCR",
    field_lot_area: "800",
    field_property_image:
      "/sites/default/files/2023-08/638037cab8fcb25cb2e8ad4d_webaliser-_TPTXZd9mOo-unsplash-p-500.jpg",
    field_property_no: "5",
    field_type: "Residential Area",
    field_price: "900,000",
  },
];

function* processAcquiredProperties(): ISaga {
  try {
    const { data: page } = yield call(getAcquiredPropertiesPage);
    const { data: list } = yield call(getAcquiredPropertiesList);
    const payload: AutoLoansData = {
      page,
      list: SAMPLE_PROPERTIES,
    };

    yield put(getAcquiredPropertiesPageDataSuccess(payload));
  } catch (error) {
    yield put(getAcquiredPropertiesPageDataFailed());
  }
}

export default function* watcher() {
  yield takeLatest(
    "REQUEST_ACQUIRED_PROPERTIES_DATA",
    processAcquiredProperties
  );
}
